import styled from "@emotion/styled";
import { Link } from "@mui/material";

export const LinkWrapper = styled(Link)({
  cursor: "pointer",
  textDecoration: "none",
});
